import { AgentProvider } from '../contexts/AgentContext';
import { EvaluatorProvider } from '../contexts/EvaluatorContext';
import { GlobalProvider } from '../contexts/GlobalProvider';
import { PersonaProvider } from '../contexts/PersonaContext';
import { SimulationProvider } from '../contexts/SimulationContext';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <GlobalProvider>
      <AgentProvider>
        <EvaluatorProvider>
          <PersonaProvider>
            <SimulationProvider>{children}</SimulationProvider>
          </PersonaProvider>
        </EvaluatorProvider>
      </AgentProvider>
    </GlobalProvider>
  );
}
